import Model from "./base/model";

class RequestSimulationRefusalJustification extends Model {
  resourceName() {
    return "request_simulation_refusal_justification";
  }

  fields() {
    return {
      justification: "",

    };
  }

}

export default new RequestSimulationRefusalJustification();
